module.exports = __webpack_public_path__ + "static/media/cr-logo-new.bc6ce7eb.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/cr-logo-new.png
// module id = 136
// module chunks = 0